import React from "react";

const STEPS = [
  { key: "received", label: "Reçue" },
  { key: "preparing", label: "En cuisine" },
  { key: "delivering", label: "En route" },
  { key: "delivered", label: "Livrée" },
];

/** Signature visuelle NelDaari : le logo « N » se remplit de rouge au fil des
 * étapes de la commande (reçue → en cuisine → en route → livrée). */
export const BrandProgress = ({ status }) => {
  const idx = STEPS.findIndex((s) => s.key === status);
  if (idx === -1) return null; // statuts annulés / inconnus : rien
  const pct = ((idx + 1) / STEPS.length) * 100;
  return (
    <div className="bg-white border border-sand rounded-2xl p-4 mb-6 flex items-center gap-4" data-testid="brand-progress">
      {/* Le logo qui se remplit de couleur au fil des étapes */}
      <div className="relative w-16 h-16 shrink-0">
        {/* Version grisée en fond */}
        <img src="/logo-neldaari.png" alt="" className="absolute inset-0 w-16 h-16 grayscale opacity-40" />
        {/* Version couleur révélée du bas vers le haut */}
        <img
          src="/logo-neldaari.png"
          alt="NelDaari"
          className="absolute inset-0 w-16 h-16 transition-[clip-path] duration-700 ease-out"
          style={{ clipPath: `inset(${100 - pct}% 0 0 0)` }}
          data-testid="brand-progress-fill"
        />
      </div>
      {/* Étapes */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-1">
          {STEPS.map((s, i) => (
            <div key={s.key} className="flex-1 text-center" data-testid={`brand-progress-step-${s.key}`}>
              <div className={`mx-auto w-2.5 h-2.5 rounded-full mb-1 ${i <= idx ? "bg-brand-red" : "bg-sand"} ${i === idx ? "ring-4 ring-brand-red/20" : ""}`} />
              <div className={`text-[11px] font-semibold truncate ${i <= idx ? "text-ink" : "text-mute"}`}>{s.label}</div>
            </div>
          ))}
        </div>
        <div className="mt-2 h-1.5 rounded-full bg-elevated overflow-hidden">
          <div className="h-full bg-brand-red rounded-full transition-[width] duration-700 ease-out" style={{ width: `${pct}%` }} />
        </div>
      </div>
    </div>
  );
};

export default BrandProgress;
